import { DefaultError, useQuery } from '@tanstack/react-query';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { IVideoContractsTime } from './types';

export const useGetVideoContractFuture = (videoId: string) => {
  const { responseHandler } = useResponseHandler();
  return useQuery<IVideoContractsTime, DefaultError>({
    queryKey: ['video-contract-future', videoId],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Video/Contract/Future`,
        params: { videoId },
      });

      return responseHandler(response, {
        groupName: `useGetVideoContractFuture - ${videoId}`,
      });
    },
  });
};

export const useGetVideoContractHistory = (videoId: string) => {
  const { responseHandler } = useResponseHandler();
  return useQuery<IVideoContractsTime, DefaultError>({
    queryKey: ['video-contract-history', videoId],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Video/Contract/History`,
        params: { videoId },
      });

      return responseHandler(response, {
        groupName: `useGetVideoContractHistory - ${videoId}`,
      });
    },
  });
};
